import React, { useEffect, useRef } from "react";
import styles from "./insurance-comp.module.scss";

const PopUp = ({
  options,
  click,
  close,
}: {
  options: string[];
  click: (selection: string) => void;
  close: () => void; // Add a callback to close the popup
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        close(); // Invoke the close callback
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [close]);

  return (
    <div className={styles["out-contain"]}>
      <div ref={popupRef} className={styles.contain}>
        <div className={styles["sel-contain"]}>
          <span>SELECT</span>
        </div>
        <div className={styles["scrollable-container"]}>
          {options &&
            options.map((option) => (
              <div
                key={option}
                className={styles["item-contain"]}
                role="button"
                onClick={() => click(option)}
              >
                <span>{option}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default PopUp;
